var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-10 ml-15"},[_c('h1',[_vm._v("Create a New Post")]),(_vm.response)?_c('div',[_c('h2',[_vm._v("Response:")]),_c('pre',[_vm._v(_vm._s(_vm.response))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }